import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { BackButton } from '../../components/core';
import ScreenLeft from './components/ScreenLeft';
import ScreenRight from './components/ScreenRight';

import CustomCursor from './components/CustomCursor';
import useMobile from '../../other/Hooks/useMobile';

const SplitScreenContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
`;

const BackButtonContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 3;
  cursor: pointer;
`;

const Divider = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  background-color: white;

  height: 0vh;
  width: 1px;
`;

type Props = {
  backToWelcome: (e: React.MouseEvent) => void
  enter: boolean
}

const SplitScreen = ({ backToWelcome, enter }: Props) => {
  const [showControls, setShowControls] = useState(false);
  const [mouseOnLeftSide, setMouseOnLeftSide] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [focusedScreen, setFocusedScreen] = useState('' as '' | 'left' | 'right');
  const isMobile = useMobile()
  const mouseRef = useRef(null);

  window.addEventListener('resize', () => {
    setScreenWidth(window.innerWidth);
  });

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (isMobile) return
    // @ts-ignore
    mouseRef.current.setAttribute('style', `transform: translate(${e.clientX + 60}px, ${e.clientY + 65}px);`);
    if (e.clientX <= screenWidth / 2 && !mouseOnLeftSide) {
      setMouseOnLeftSide(true);
    } else if (e.clientX > screenWidth / 2 && mouseOnLeftSide) {
      setMouseOnLeftSide(false);
    }
  };

  const handleScreenClick = () => {
    if (focusedScreen || isMobile) return;

    if (mouseOnLeftSide) {
      setFocusedScreen('left');
    } else {
      setFocusedScreen('right');
    }
  };

  const backToSplit = () => {
    setFocusedScreen('');
  };

  useEffect(() => {
    if (enter) {
      setTimeout(() => {
        setShowControls(true);
      }, 500);
    } else {
      setShowControls(false);
    }
  }, [enter]);

  return (
    <SplitScreenContainer onMouseMove={handleMouseMove} onClick={handleScreenClick}>

      {
        isMobile && showControls && !focusedScreen
          ? <>

            <CustomCursor onClick={() => setFocusedScreen('left')} key={1} showControls mouseOnLeftSide />
            <CustomCursor onClick={() => setFocusedScreen('right')} key={2} showControls />

          </>
          : <CustomCursor mouseRef={mouseRef} showControls={showControls && !focusedScreen} mouseOnLeftSide={mouseOnLeftSide} />
      }

      {
        showControls && !focusedScreen &&
        <BackButtonContainer onClick={backToWelcome}>
          <BackButton text='Back' />
        </BackButtonContainer>
      }
      { showControls && !focusedScreen && <Divider className='growVertically' />}

      <ScreenLeft enter={enter} focusedScreen={focusedScreen} setFocusedScreen={setFocusedScreen} backToSplit={backToSplit} />

      <ScreenRight enter={enter} focusedScreen={focusedScreen} setFocusedScreen={setFocusedScreen} backToSplit={backToSplit} />

    </SplitScreenContainer>
  );
};

export default SplitScreen;